import { render } from "./ReminderComplete.vue?vue&type=template&id=4d9cb685"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ReminderComplete.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d9cb685"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d9cb685', __exports__)) {
    api.reload('4d9cb685', __exports__)
  }
  
  module.hot.accept("./ReminderComplete.vue?vue&type=template&id=4d9cb685", () => {
    api.rerender('4d9cb685', render)
  })

}


export default __exports__